import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "canvas" ]
  static values = {
    logoModelPrerenderedUrl: String
  }

  async connect() {
    var isMobile = Math.min(window.screen.width, window.screen.height) < 768 || navigator.userAgent.indexOf("Mobi") > -1;
    if (!isMobile) {
      this.renderLogo(false)
    } else {
      const ctx = this.canvasTarget.getContext('2d')

      const defImg = new Image()
      defImg.src = this.logoModelPrerenderedUrlValue
      defImg.onload = () => {
        ctx.drawImage(defImg, 0, 0)
      }
    }
  }

  async renderLogo(isLowFPS) {
    const THREE = await import('three')
    const canvas = this.canvasTarget
    this.renderer = new THREE.WebGLRenderer({ canvas, alpha: true, preserveDrawingBuffer: true })

    const fov = 65
    const aspect = 1
    const near = 0.1
    const far = 5
    this.camera = new THREE.PerspectiveCamera(fov, aspect, near, far)
    this.camera.position.z = 2

    this.scene = new THREE.Scene()
    const boxWidth = 1
    const boxHeight = 1
    const boxDepth = 1
    const geometry = new THREE.IcosahedronGeometry(1, 0)
    const material = new THREE.MeshPhongMaterial({ color: 0xEEEEEE })
    this.cube = new THREE.Mesh(geometry, material)

    this.scene.add(this.cube)

    this.light = new THREE.DirectionalLight(0xFFFFFF, 1)
    this.light.position.set(-1, 2, 4)
    this.scene.add(this.light)

    const render = (time) => {
      time *= 0.001

      this.cube.rotation.x = time / 2
      this.cube.rotation.y = time / 2

      this.renderer.render(this.scene, this.camera)
    }

    let clock = new THREE.Clock()
    let delta = 0
    let interval = 1 / 30
    if (isLowFPS) {
      interval = 1 / 10
    }

    const update = (time) => {
      this.id = requestAnimationFrame(update)
      delta += clock.getDelta()

      if (delta  > interval) {
        // The draw or time dependent code are here
        render(time)

        delta = delta % interval
      }
    }

    update()
  }

  disconnect() {
    if (this.id) {
      cancelAnimationFrame(this.id)
    }
    this.scene = null
    this.light = null
    this.camera = null
    this.renderer = null
  }
}
